export default function SuccessSend({ type = "success" }) {
  const isSuccess = type === "success";

  return (
    <div
      className={`successMessage ${
        isSuccess ? "successMessage--ok" : "successMessage--error"
      }`}
      role="alert"
    >
      {isSuccess ? "Successfully sent" : "Error while sending"}{" "}
      <img
        src={isSuccess ? "/images/check.svg" : "/images/crossWhite.svg"}
        alt={isSuccess ? "success" : "error"}
      />
    </div>
  );
}
